import React from "react";

import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Divider,
  Stack,
  SxProps,
  Theme,
  Typography,
} from "@mui/material";

import { ObituaryMediaResponse } from "@/extensions/mediahouse/types";
import { Layout, layoutName } from "@/extensions/obituary/types";

import * as format from "@/utils/format";

export interface RowProps {
  label: string;
  value: string;
}

export const Row: React.FC<RowProps> = ({ label, value }) => {
  return (
    <Stack direction="row" justifyContent="space-between">
      <Typography color="text.secondary" variant="body2">
        {label}
      </Typography>
      <Typography variant="body2">{value}</Typography>
    </Stack>
  );
};

export interface AdCardProps {
  obituaryMedia: ObituaryMediaResponse;
}
const figureStyle: SxProps<Theme> = (theme) => ({
  bgcolor: "background.paper",
  ...theme.applyStyles("light", {
    backgroundColor: "#e5e5e5",
  }),
  p: 2,
  m: 0,
  borderColor: "divider",
  borderWidth: 0,
  borderRightWidth: { md: 1, xs: 0 },
  borderBottomWidth: { md: 0, xs: 1 },
  borderStyle: "solid",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: { md: 200, xs: 100 },
});
const AdCard: React.FC<AdCardProps> = ({ obituaryMedia }) => {
  return (
    <Card
      sx={{
        boxShadow: "none",
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 3,
      }}
    >
      <CardContent sx={{ p: "0 !important" }}>
        <Stack p={2} spacing={3}>
          <Typography gutterBottom fontWeight={500} variant="body1">
            Annons
          </Typography>
          <Stack spacing={1.25}>
            <Row
              label="Typ"
              value={layoutName[obituaryMedia.layout_variant as Layout]}
            />
            <Row label="Höjd" value={`${obituaryMedia.height.toFixed(1)} mm`} />
            <Row label="Bredd" value={`${obituaryMedia.width.toFixed(1)} mm`} />
            <Divider />
            <Row
              label="Rabatt"
              value={`${obituaryMedia.discount_pct.toFixed(1)} %`}
            />
            <Row label="Kostnad" value={format.price(obituaryMedia.cost)} />
          </Stack>
        </Stack>
        <Stack alignItems="center" bgcolor="grey.100" p={2}>
          {obituaryMedia.preview_url && obituaryMedia.preview_url !== "" && (
            <Box
              aria-label="Förhandsvisning"
              component="figure"
              sx={figureStyle}
            >
              <Box component="img" src={obituaryMedia.preview_url} />
            </Box>
          )}
        </Stack>

        <CardActions sx={{ justifyContent: "flex-end", p: 2 }}>
          {obituaryMedia.printing_original_url && (
            <Button
              download
              href={obituaryMedia.printing_original_url}
              variant="outlined"
            >
              Ladda ned som pdf
            </Button>
          )}
        </CardActions>
      </CardContent>
    </Card>
  );
};

export default AdCard;
